export interface CompetitorRow {
  feature: string;
  manual: string | boolean;
  competitors: string | boolean;
  eridon: string | boolean;
  highlight?: boolean;
}

export const COMPARISON: CompetitorRow[] = [
  { feature: "Время на выпуск erid", manual: "2–24 часа", competitors: "5–10 минут", eridon: "2 секунды", highlight: true },
  { feature: "ИИ-проверка ФЗ-168 (иностранные слова)", manual: false, competitors: false, eridon: true, highlight: true },
  { feature: "Авто-отчётность в ЕРИР", manual: false, competitors: "Полу-ручная", eridon: true },
  { feature: "Прямые интеграции с ОРД", manual: "—", competitors: "1–2 ОРД", eridon: "4 ОРД", highlight: true },
  { feature: "Маркировка изображений и видео", manual: false, competitors: "Только текст", eridon: true },
  { feature: "Юр. гарантия от штрафа", manual: false, competitors: false, eridon: true, highlight: true },
  { feature: "Цена входа", manual: "Время сотрудника", competitors: "от 5 000 ₽/мес", eridon: "1 ERID бесплатно, далее от 1 425 ₽/мес", highlight: true },
  { feature: "Экспорт в 1С (XML EnterpriseData)", manual: false, competitors: "Не у всех", eridon: true },
  { feature: "Поддержка 24/7", manual: "—", competitors: "Email", eridon: "Telegram + email" },
  { feature: "Возврат денег без вопросов", manual: "—", competitors: "Редко", eridon: "14 дней" },
];
